import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import About from "./pages/About";
import Press from "./pages/Press";
import PropertiesEngine from "./pages/PropertiesEngine";
import Contact from "./pages/Contact";

import PropertyComponent from "./components/PropertyComponent";
import Header from "./components/Header";
import Test from "./pages/Test";
import Footer from "./components/Footer";
import ModernProperties from "./pages/ModernProperties";
import RusticProperties from "./pages/RusticProperties";
import ResaleProperties from "./pages/ResaleProperties";
import Investors from "./pages/Investors";
import YourRealtor from "./pages/YourRealtor";
import LoadingData from "./LoadingData";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 500); // Show loading for 2 seconds
    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, []);

  if (isLoading) {
    return (
      <div className="LoadingScreen">
        <LoadingData />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/about" element={<About />} />
          <Route path="/press" element={<Press />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/yourrealtor" element={<YourRealtor />} />
          <Route path="/properties" element={<PropertiesEngine />} />
          <Route path="/ModernProperties" element={<ModernProperties />} />
          <Route path="/RusticProperties" element={<RusticProperties />} />
          <Route path="/ResaleProperties" element={<ResaleProperties />} />
          <Route path="/:slug" element={<PropertyComponent />} />
          <Route path="/test" element={<Test />} />
        </Routes>
      </Router>
      <Footer />
    </div>
  );
}

export default App;
